export default "__VITE_ASSET__ChhUc53Z__"